import {makeStyles} from "@material-ui/core/styles"
import {deepPurple} from "@material-ui/core/colors"

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: "30px 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 50px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  heading: {
    color: "rgba(0,183,255, 1)",
    textDecoration: "none",
  },
  image: {
    marginLeft: "10px",
    marginTop: "5px",
  },
  toolbar: {},
  profile: {display: "flex", flexDirection: "row", alignItems: "center"},

  brandContainer: {
    display: "flex",
    alignItems: "center",
  },
  userName: {paddingLeft: "10px"},
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
    height: "2em",
    width: "2em",
  },
  logout: {
    color: "white",
    backgroundColor: "#ff418a",
    "&:hover": {
      backgroundColor: "#f13a62",
    },
  },
  signIn: {
    color: "white",
    backgroundColor: "#2D93D3",
    "&:hover": {
      backgroundColor: "#1e88ca",
    },
  },
}))
